import ApiClient from "Store/client";

export const fetchStudentSubjectsApi = () => ApiClient(`api/subjects`);
export const fetchStudentUnitsBySubjectApi = (studentId: string, subjectId: string) =>
  ApiClient<Subject[]>(`api/students/${studentId}/units?subject_id=${subjectId}`);
